import React, {useState, useContext, useRef} from 'react'
import { IonInput, IonButton, IonItem, IonList, IonModal } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';

import { Plugins } from '@capacitor/core';
import Cookie from 'universal-cookie';


import { Auth_ClientID_context } from '../../../storeState/auth_clientID_context'

const { Storage } = Plugins;
let cookie = new Cookie();

async function setStorageCredentials_client(event) {

    Storage.set({
        key: 'accountID',
        value: event[0],
    })
    Storage.set({
        key: 'schemaName',
        value: event[1],
    })
    Storage.set({
        key: 'isAuthenticated',
        value: event[2],
    })
    Storage.set({
        key: 'loginUsername_authenticated',
        value: event[3],
    })
    Storage.set({
        key: 'loginPassword_authenticated',
        value: event[4],
    })
    /*Storage.set({
        key: 'accessRights',
        value: [event[3], event[4], event[5], event[6]],
    })*/

}

function setCookie(event) {

    cookie.set(event[0], event[1]);
}

export function ClientLoginCredentials (props) {

    let authenticatedClient_context = useContext(Auth_ClientID_context);


    let [loginUsername, setLoginUsername ] = useState('');
    let [loginPassword, setLoginPassword ] = useState('');

    let [baseURL, setBaseURL ] = useState(authenticatedClient_context.baseURL);

    let [landingPage, setLandingPage] = useState(null);


    const usernameChangeHandler = (event) => {
        setLoginUsername(event.target.value);
    }

    const passwordChangeHandler = (event) => {
        setLoginPassword(event.target.value);
    }


    function handleConfirmClientLogin() {

        if(loginUsername.trim().length === 0 || loginPassword.trim().length === 0)
        {
            return;
        }

        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '73000',
                xUsername: loginUsername,
                xPassword: loginPassword,
            })
        }

        //await fetch(baseURL+'merchants_argsApp', requestOptions)
        fetch(baseURL+'users_argsjqApp', requestOptions)
        .then(res => res.json())
        .then(res => {

                    let lines = res.out.toString().split('|');

                            //if (lines[0] === "2" || lines[0] === "3")
                            //{
                                //setStorageCredentials_client([lines[1], lines[2], lines[3], lines[4], lines[5], lines[6], lines[7]]);
                                setStorageCredentials_client([lines[1], lines[2], 'yesc', loginUsername, loginPassword]);
                                setCookie([lines[1], res.id]);
                                setLandingPage('/clientMainPageApp');

                                authenticatedClient_context.changeLoginUsername(loginUsername);
                                authenticatedClient_context.changeLoginPassword(loginPassword);

                                setLoginUsername('');
                                setLoginPassword('');

                                authenticatedClient_context.changeAccountID(lines[1]);
                                authenticatedClient_context.changeSchema(lines[2]);
                                authenticatedClient_context.changeAuthenticated('yesc');
                                //authenticatedclient_context.changeAccessRights([lines[4], lines[5], lines[6], lines[7]]);

                            //}

                })
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    //alert('in LoginCredential_client');
    //alert(authenticatedClient_context.authenticated );
    //alert(landingPage);
    
    return  <React.Fragment>
                {(landingPage == null && props.openModal == true) ? 
                    (<IonModal isOpen={ props.openModal }>
                        <IonList>
                            <IonItem>
                                <IonInput id="merchantUsername" placeholder="Enter Username" value={loginUsername} onIonChange={usernameChangeHandler }></IonInput>
                                <IonInput type='password' id="merchantPassword" placeholder="Enter Password" value={loginPassword} onIonChange={passwordChangeHandler }></IonInput>
                            </IonItem>
                            <IonItem>
                                <IonButton onClick={ handleConfirmClientLogin }> Login</IonButton>
                            </IonItem>
                        </IonList>
                        
                        <IonButton onClick={() => props.closeModal(false)}>Close</IonButton>

                        </IonModal>) : 
                    (<Redirect to={ landingPage } /> )
                    }

            </React.Fragment>
}